import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { ErrorState } from "@kit-v5";
import { t } from "../i18n/i18n";
function targetKeyOf(props) {
    return `${props.slug ?? ""}#${props.view ?? ""}`;
}
// Сбрасывается при смене цели (продукт/дверь) — иначе ошибка на продукте A
// навсегда закрывает экран, даже когда пользователь ушёл на рабочий продукт B.
export default class ModuleErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, errorMessage: "", resetKey: 0, targetKey: targetKeyOf(props) };
    }
    static getDerivedStateFromProps(props, state) {
        const targetKey = targetKeyOf(props);
        if (targetKey === state.targetKey)
            return null;
        return state.hasError
            ? { hasError: false, errorMessage: "", resetKey: state.resetKey + 1, targetKey }
            : { targetKey };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, errorMessage: error instanceof Error ? error.message : String(error) };
    }
    componentDidCatch(error, info) {
        console.error(`[ModuleErrorBoundary] slug=${this.props.slug ?? "unknown"}`, error, info);
    }
    handleReload = () => {
        this.setState((s) => ({ hasError: false, errorMessage: "", resetKey: s.resetKey + 1 }));
    };
    render() {
        if (this.state.hasError) {
            return (_jsx("div", { className: "osn-module-error", children: _jsx(ErrorState, { title: this.props.slug ? t("shell.module.error_title_slug", { slug: this.props.slug }) : t("shell.module.error_title"), message: this.state.errorMessage, onRetry: this.handleReload }) }));
        }
        return _jsx(React.Fragment, { children: this.props.children }, this.state.resetKey);
    }
}
